"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppState_enum_1 = require("../types/enums/AppState.enum");
var OptiivaSdkContext = react_1.default.createContext([
    {
        errors: {},
        success: null,
        loadId: null,
        state: AppState_enum_1.AppState.ready,
        user: null,
    },
    function () { return ({}); },
]);
exports.OptiivaSdkProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var _b = react_1.useState(value), state = _b[0], setState = _b[1];
    return (react_1.default.createElement(OptiivaSdkContext.Provider, { value: [state, setState] }, children));
};
exports.useOptiivaSdk = function () {
    var _a = react_1.useContext(OptiivaSdkContext), context = _a[0], setContext = _a[1];
    var updateContext = function (newState) {
        setContext(function (s) { return (__assign(__assign({}, s), newState)); });
    };
    var setErrors = function (errors) {
        setContext(function (s) { return (__assign(__assign({}, s), { errors: errors })); });
    };
    return {
        context: context,
        updateContext: updateContext,
        setErrors: setErrors,
    };
};
//# sourceMappingURL=OptiivaSdk.js.map